import { getVidoeSrc } from '@/common/video/playlistJsonUtils';
import { getCoverImageForOGImage } from '@/common/media';
import {
  BodyContentType,
  Content,
  ContentBody,
  SelectedMedia,
} from '@/lib/model';
import { isAudioType, isVideoType } from '@/utils/contentType/mediaType';

export function getContentJsonLdSchema(content?: Content, body?: ContentBody) {
  const mainContentImage = content?.coverImage as SelectedMedia;
  const mainImageUrl = getCoverImageForOGImage(mainContentImage) || '';
  const mainImage =
    mainImageUrl !== '/png/placeholder.png' ? mainContentImage : undefined;
  const contentMedia = content?.media as SelectedMedia;
  const isVideo = isVideoType(contentMedia);
  const isAudio = isAudioType(contentMedia);
  const mainVideo = isVideo
    ? {
        url: getVidoeSrc(contentMedia),
        ...contentMedia,
      }
    : undefined;

  const mainAudio = isAudio
    ? {
        url: contentMedia?.media?.url,
        ...contentMedia,
      }
    : undefined;
  if (!body)
    return {
      mainImage,
      mainImageUrl,
      images: [],
      mainVideo,
      videos: [],
      twitters: [],
      youtubes: [],
    };
  const videos =
    body?.content?.filter(c => c.type === BodyContentType.VideoBlock) || [];
  const images =
    body?.content?.filter(c => c.type === BodyContentType.ImageBlock) || [];
  const twitters =
    body?.content?.filter(c => c.type === BodyContentType.Twitter) || [];
  const youtubes =
    body?.content?.filter(c => c.type === BodyContentType.Youtube) || [];
  return {
    mainImage,
    mainImageUrl,
    images,
    mainVideo,
    videos,
    twitters,
    youtubes,
    mainAudio,
  };
}
